<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <settings
            v-bind:title="resource('TemplateColumnButtonSettings_Settings_Title')"
            v-bind:region="'right'"
            class="column-content-settings button-settings"
    >
        <template v-slot:body>
            <settings-slider
                v-model="model.style.containerHeight"
                v-bind:label="resource('TemplateColumnButtonSettings_ContainerHeight_Label')"
                value-suffix="px"
                v-bind:min="1"
                v-bind:max="250"
            >
            </settings-slider>
            
            <settings-slider
                    v-model="model.style.width"
                    v-bind:label="resource('TemplateManager_Shared_Width_Label')"
                    v-bind:value-suffix="'%'"
            >
            </settings-slider>
            
            <settings-slider
                    v-model="model.style.height"
                    v-bind:label="resource('TemplateManager_Shared_Height_Label')"
                    v-bind:value-suffix="'%'"
            >
            </settings-slider>
            

            <settings-color-picker
                    v-model="model.style.backgroundColor"
                    v-bind:label="resource('TemplateManager_Shared_BackgroundColor_Label')"
            >
            </settings-color-picker>

            <settings-color-picker
                    v-model="model.style.borderColor"
                    v-bind:label="resource('TemplateColumnButtonSettings_BorderColor_Label')"
            >
            </settings-color-picker>
            
            <settings-textbox
                v-model="model.link"
                v-bind:label="resource('TemplateManager_Shared_Link_Label')"
            >
            </settings-textbox>
            
            <settings-slider
                v-model="model.style.borderRadius"
                v-bind:label="resource('TemplateColumnButtonSettings_BorderRadius_Label')"
                v-bind:value-suffix="'px'"
                
                v-bind:min="0"
                v-bind:max="30"
            >    
            </settings-slider>
            
            <settings-position
                v-model="model.style.position"
                v-bind:label="resource('TemplateManager_Shared_Position_Label')"
            >
            </settings-position>
        </template>
    </settings>
</template>

<script>
    import settingsMixin from '../../Mixins/settings'
    import resourceMixin from "../../../../Util/Mixins/resources";

    export default {
        name: "template-column-button-settings",
        mixins: [settingsMixin, resourceMixin]
    };
</script>
